export const routes = {
    root: '/',
    update: '/profile/update',
    tokenCallback: '/sso/token/callback',
    recoverSendCode: '/recover-send-code',
    recoverVerifyCode: '/recover-verify-code',
    recover: '/recover',
    recoverLink: '/recovery',
    signIn: '/sign-in',
    signUp: '/sign-up',
    signUpChallengeQuestions: '/more-info',
    signUpError: '/sign-up/error',
    verify: '/verify',
    mfaSelect: '/mfa/select',
    totpPreSetup: '/mfa/totp/pre-setup',
    totpSetup: '/mfa/totp/setup',
    totpVerify: '/mfa/totp/verify',
    profile: '/profile',
    sso: '/sso',
    invalidLink: '/invalid-link',
    wildcard: '*',
};
